import { render } from "./Liquidation.vue?vue&type=template&id=25217d78"
import script from "./Liquidation.vue?vue&type=script&lang=js"
export * from "./Liquidation.vue?vue&type=script&lang=js"
script.render = render

export default script